//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { ParentInputItem } from './ParentInputItem';

export class MoveStudentToFamilyUpdateItem extends ItemBase {
    NewFamilyID: string | null = null;
    ParentInputItem: ParentInputItem | null = null;

    constructor(initializer?: Partial<MoveStudentToFamilyUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "MoveStudentToFamilyUpdateItem";
}
